import { Box, Button } from '@mui/material';
import { CaretLeft, CaretRight, CheckCircle } from '@phosphor-icons/react';

interface WizardNavigationProps {
  currentStep: number;
  onBack: () => void;
  onNext: () => void;
  canProceed: boolean;
  showBack: boolean;
  /** When true, the Next button is hidden (e.g. on final choice step) */
  hideNext?: boolean;
  /** Label for the primary action button (e.g. "Finish" on last step). Default "Next". */
  nextButtonLabel?: string;
}

const WizardNavigation = ({
  onBack,
  onNext,
  canProceed,
  showBack,
  hideNext = false,
  nextButtonLabel = 'Next',
}: WizardNavigationProps) => {
  const isFinish = nextButtonLabel === 'Finish';
  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'lightGray.main',
        py: 2,
        px: 4,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 10,
      }}
    >
      {/* Back button */}
      <Box>
        {showBack && (
          <Button
            variant="outlined"
            onClick={onBack}
            startIcon={<CaretLeft size={20} weight="bold" />}
            sx={{
              borderColor: 'lightGray.main',
              color: 'custom.textBlue',
              textTransform: 'none',
              borderRadius: '8px',
              height: '34px',
              px: 3,
              fontSize: '14px',
              fontWeight: 500,
              '&:hover': {
                borderColor: 'primary.main',
                bgcolor: 'custom.sidebarActiveBg',
              },
            }}
          >
            Back
          </Button>
        )}
      </Box>

      {/* Next/Finish button - hidden when hideNext (e.g. on choice step) */}
      {!hideNext && (
        <Box>
          <Button
            variant="contained"
            onClick={onNext}
            disabled={!canProceed}
            endIcon={
              isFinish ? (
                <CheckCircle size={20} weight="bold" />
              ) : (
                <CaretRight size={20} weight="bold" />
              )
            }
            sx={{
              backgroundColor: 'primary.main',
              color: 'white',
              textTransform: 'none',
              borderRadius: '8px',
              height: '34px',
              px: 4,
              fontSize: '14px',
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: 'custom.tertiary',
                boxShadow: 'none',
              },
              '&:disabled': {
                backgroundColor: 'lightGray.main',
                color: 'lightGray.text',
              },
            }}
          >
            {nextButtonLabel}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default WizardNavigation;
